import { useMapContext } from '../contexts/mapContext';
import { SELECTED_FEATURE_PROPERTY } from '../constants/mapConstants';
import { useEffect } from 'react';

export default function useData() {
	const [{ data, selectedFeatureProperty }, { setRawData }] = useMapContext();

	useEffect(() => {
		data?.features?.forEach((feature: any) => {
			let value = 1;
			if (selectedFeatureProperty) {
				value = Number(feature.properties?.[selectedFeatureProperty]);
				if (isNaN(value)) value = 0;
			}
			feature.properties[SELECTED_FEATURE_PROPERTY] = value;
		});
		data?.features.sort((a: any, b: any) => {
			const aVal = a.properties[SELECTED_FEATURE_PROPERTY];
			const bVal = b.properties[SELECTED_FEATURE_PROPERTY];
			if (aVal < bVal) return -1;
			else if (aVal > bVal) return 1;
			else return 0;
		});
		// console.log('GEOJSON DATA:', data);
		setRawData(Object.assign({}, data));
	}, [data, setRawData, selectedFeatureProperty]);
}
